import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-io-runtime-api-reference"
    }}>{`Adobe I/O Runtime API Reference`}</h1>
    <h2 {...{
      "id": "api-endpoints"
    }}>{`API endpoints`}</h2>
    <p>{`Adobe I/O Runtime supports the following API endpoints for interacting programmatically with the service. `}</p>
    <p><strong parentName="p">{`Notes:`}</strong></p>
    <ol>
      <li parentName="ol">{`Unless otherwise noted, all parameters are required. `}</li>
      <li parentName="ol">{`For all the API calls on this page, the base URL is:`}<br parentName="li"></br>
        <inlineCode parentName="li">{`https://api.adobe.io/`}</inlineCode></li>
    </ol>
    <h3 {...{
      "id": "get-runtimeadminnamespacesorgidintid"
    }}>{`GET /runtime/admin/namespaces/{orgId}/{intId}`}</h3>
    <p>{`Returns the details of the namespace associated with the specified organization and integration.`}</p>
    <h4 {...{
      "id": "parameters"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Code`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`200`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Successful operationExample value:`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`{
"name": "string",
"auth": "string"
}
Model:
NamespaceDTO {
description: Namespace Details
name    string
Namespace name
auth    string
Auth associated with Namespace
}|`}</p>
    <h3 {...{
      "id": "post-runtimeadminnamespacesorgidintid"
    }}>{`POST /runtime/admin/namespaces/{orgId}/{intId}`}</h3>
    <p>{`Creates a new namespace and returns the details of the newly created namespace. If namespace already exists it returns the details of the namespace.`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-1"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"name": "string",
"auth": "string"
}
Model:
NamespaceDTO {
description: Namespace Details
name    string
Namespace name
auth    string
Auth associated with Namespace
}|`}</p>
    <h3 {...{
      "id": "delete-runtimeadminnamespacesorgidintid"
    }}>{`DELETE /runtime/admin/namespaces/{orgId}/{intId}`}</h3>
    <p>{`Deletes the namespace associated with the specified organization and integration.`}</p>
    <h4 {...{
      "id": "parameters-2"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-2"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
| Code | Description |
|---|---|
| `}<em parentName="p">{`default`}</em>{` | Successful operation |`}</p>
    <h3 {...{
      "id": "get-runtimenamespacesorgidintidactions"
    }}>{`GET /runtime/namespaces/{orgId}/{intId}/actions`}</h3>
    <p>{`Returns the list of actions associated with the specified organization and integration.`}</p>
    <h4 {...{
      "id": "parameters-3"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-3"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
[
{
"name": "string",
"code": "string",
"namespace": "string",
"version": "string",
"params": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"limits": {
"timeout": "string",
"memory": "string",
"logs": "string"
},
"exec": {
"kind": "string",
"binary": false,
"components": `}{`[
"string"
]`}{`
},
"url": "string"
}
]
Model:
[ActionDTO {
description: OpenWhisk Action
name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
params      `}{`[Action params
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
limits      LimitsDTO {
description: OpenWhisk Action Limits
timeout     string
Action timeout
memory      string
Action memory limit
logs        string
Action logs
}
exec        ExecDTO {
description: OpenWhisk Action exec details
kind    string
Action kind
binary  boolean
default: false
Is action binary
components  `}{`[
Action components in case of sequence
string]`}{`
}
url         string
Action url
}]|`}</p>
    <h3 {...{
      "id": "post-runtimenamespacesorgidintidactions"
    }}>{`POST /runtime/namespaces/{orgId}/{intId}/actions`}</h3>
    <p>{`Creates a new action.`}</p>
    <h4 {...{
      "id": "parameters-4"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`orgId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`intId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`body (body)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action form.  Example value:`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`{
"name": "string",
"code": "string",
"namespace": "string",
"version": "string",
"params": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"limits": {
"timeout": "string",
"memory": "string",
"logs": "string"
},
"exec": {
"kind": "string",
"binary": false,
"components": `}{`[
"string"
]`}{`
},
"url": "string"
}Parameter content type: application/json
Model:
[ActionDTO {
description: OpenWhisk Action`}</p>
    <p>{`name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
params      `}{`[Action params
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
limits      LimitsDTO {
description: OpenWhisk Action Limits
timeout     string
Action timeout
memory      string
Action memory limit
logs        string
Action logs
}
exec        ExecDTO {
description: OpenWhisk Action exec details
kind    string
Action kind
binary  boolean
default: false
Is action binary
components  `}{`[
Action components in case of sequence
string]`}{`
}
url         string
Action url
}]|
|Authorization (string: header)|Authorization token in format: Bearer {token}|
|X-Api-Key (string: header)|Api key|`}</p>
    <h4 {...{
      "id": "responses-4"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
| Code | Description |
|---|---|
| `}<em parentName="p">{`default`}</em>{` | Successful operation |`}</p>
    <h3 {...{
      "id": "get-runtimenamespacesorgidintidactionsname"
    }}>{`GET /runtime/namespaces/{orgId}/{intId}/actions/{name}`}</h3>
    <p>{`Returns the details of an action.`}</p>
    <h4 {...{
      "id": "parameters-5"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-5"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"name": "string",
"namespace": "string",
"activationId": "string",
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"duration": 0,
"version": "string",
"response": {}
}
Model:
[ActionDTO {
description: OpenWhisk Action
name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
params      `}{`[Action params
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
limits      LimitsDTO {
description: OpenWhisk Action Limits
timeout     string
Action timeout
memory      string
Action memory limit
logs        string
Action logs
}
exec        ExecDTO {
description: OpenWhisk Action exec details
kind    string
Action kind
binary  boolean
default: false
Is action binary
components  `}{`[
Action components in case of sequence
string]`}{`
}
url         string
Action url
}]|`}</p>
    <h3 {...{
      "id": "post-runtimenamespacesorgidintidactionsname"
    }}>{`POST /runtime/namespaces/{orgId}/{intId}/actions/{name}`}</h3>
    <p>{`Executes an action.`}</p>
    <h4 {...{
      "id": "parameters-6"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-6"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"name": "string",
"code": "string",
"namespace": "string",
"version": "string",
"params": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"limits": {
"timeout": "string",
"memory": "string",
"logs": "string"
},
"exec": {
"kind": "string",
"binary": false,
"components": `}{`[
"string"
]`}{`
},
"url": "string"
}
Model:
[ActionResultDTO {
description: OpenWhisk Action invocation result
name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
duration    integer($int32)
Duration
version     string
Action Version
response    {
description:`}<br parentName="p"></br>{`
`}{`Action invocation response
}|`}</p>
    <h3 {...{
      "id": "put-runtimenamespacesorgidintidactionsname"
    }}>{`PUT /runtime/namespaces/{orgId}/{intId}/actions/{name}`}</h3>
    <p>{`Updates an action.`}</p>
    <h4 {...{
      "id": "parameters-7"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`orgId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`intId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`body (body)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action form.  Example value:`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`{
"name": "string",
"code": "string",
"namespace": "string",
"version": "string",
"params": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"limits": {
"timeout": "string",
"memory": "string",
"logs": "string"
},
"exec": {
"kind": "string",
"binary": false,
"components": `}{`[
"string"
]`}{`
},
"url": "string"
}Parameter content type: application/json
Model:
[ActionDTO {
description: OpenWhisk Action
name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
params      `}{`[Action params
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
limits      LimitsDTO {
description: OpenWhisk Action Limits
timeout     string
Action timeout
memory      string
Action memory limit
logs        string
Action logs
}
exec        ExecDTO {
description: OpenWhisk Action exec details
kind    string
Action kind
binary  boolean
default: false
Is action binary
components  `}{`[
Action components in case of sequence
string]`}{`
}
url         string
Action url
}]|
|Authorization (string: header)|Authorization token in format: Bearer {token}|
|X-Api-Key (string: header)|Api key|`}</p>
    <h4 {...{
      "id": "responses-7"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
| Code | Description |
|---|---|
| `}<em parentName="p">{`default`}</em>{` | Successful operation |`}</p>
    <h3 {...{
      "id": "delete-runtimenamespacesorgidintidactionsname"
    }}>{`DELETE /runtime/namespaces/{orgId}/{intId}/actions/{name}`}</h3>
    <p>{`Deletes an action.`}</p>
    <h4 {...{
      "id": "parameters-8"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Action name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-8"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
| Code | Description |
|---|---|
| `}<em parentName="p">{`default`}</em>{` | Successful operation |`}</p>
    <h3 {...{
      "id": "get-runtimesystemactions"
    }}>{`GET /runtime/system/actions`}</h3>
    <p>{`Returns a list of built-in actions.`}</p>
    <h4 {...{
      "id": "parameters-9"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-9"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operationExample value:
[
{
"name": "string",
"code": "string",
"namespace": "string",
"version": "string",
"params": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"annotations": `}{`[
{
"key": "string",
"value": {}
}
]`}{`,
"limits": {
"timeout": "string",
"memory": "string",
"logs": "string"
},
"exec": {
"kind": "string",
"binary": false,
"components": `}{`[
"string"
]`}{`
},
"url": "string"
}
]
Model:
[ActionDTO {
description: OpenWhisk Action
name        string
Action name
code        string
Action code
namespace   string
Action namespace
version     string
Action version
params      `}{`[Action params
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
annotations `}{`[Action annotations
KeyValuePairDTO {
description: OpenWhisk Action param
key     string
Param Name
value   {
description: Param value
}
}]`}{`
limits      LimitsDTO {
description: OpenWhisk Action Limits
timeout     string
Action timeout
memory      string
Action memory limit
logs        string
Action logs
}
exec        ExecDTO {
description: OpenWhisk Action exec details
kind    string
Action kind
binary  boolean
default: false
Is action binary
components  `}{`[
Action components in case of sequence
string]`}{`
}
url         string
Action url
}]|`}</p>
    <h3 {...{
      "id": "post-runtimenamespacesorgidintidhandleeventregistration"
    }}>{`POST /runtime/namespaces/{orgId}/{intId}/handleEventRegistration`}</h3>
    <p>{`Registers an event registration and assigns a given action to the event.`}</p>
    <h4 {...{
      "id": "parameters-10"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`orgId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`intId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`body (body)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Example value:`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`{
"id": "string",
"name": "string",
"description": "string",
"client_id": "string",
"type": "string",
"integration_status": "string",
"delivery_type": "string",
"webhook_url": "string",
"events_of_interest": `}{`[
{
"event_code": "string",
"provider": "string"
}
]`}{`,
"runtime_action": "string",
"registration_id": "string"
}Parameter content type: application/json
Model:
EventDTO {
description: Adobe I/O Event Details
id                  string
Event id
name                string
Event name
description         string
Event code
Client id           string
Event namespace
type                string
Event type
integration_status  string
Event integration status
delivery_type       string
Event delivery type
webhook_url         string
Webhook url
events_of_interest  `}{`[
Events of interest to listen to
EventsOfInterestDTO{
description: Events of interest
event_code  string
Event code
provider    string
Event provider
}]`}{`
runtime_action      string
Action to handle event
registration_id     string
Event registration id
}|
|Authorization (string: header)|Authorization token in format: Bearer {token}|
|X-Ams-Consumer-Id (string: header)|AMS consumer ID|
|X-Ams-Application-Id (string: header)|AMS application ID|
|X-Api-Key (string: header)|Api key|`}</p>
    <h4 {...{
      "id": "responses-10"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"id": "string",
"name": "string",
"description": "string",
"client_id": "string",
"type": "string",
"integration_status": "string",
"delivery_type": "string",
"webhook_url": "string",
"events_of_interest": `}{`[
{
"event_code": "string",
"provider": "string"
}
]`}{`,
"runtime_action": "string",
"registration_id": "string"
}
Model:
EventDTO {
description: Adobe I/O Event Details
id                  string
Event id
name                string
Event name
description         string
Event code
Client id           string
Event namespace
type                string
Event type
integration_status  string
Event integration status
delivery_type       string
Event delivery type
webhook_url         string
Webhook url
events_of_interest  `}{`[
Events of interest to listen to
EventsOfInterestDTO{
description: Events of interest
event_code  string
Event code
provider    string
Event provider
}]`}{`
runtime_action      string
Action to handle event
registration_id     string
Event registration id
}|`}</p>
    <h3 {...{
      "id": "delete-runtimenamespacesorgidintidhandleeventdeletionclientidregistrationid"
    }}>{`DELETE /runtime/namespaces/{orgId}/{intId}/handleEventDeletion/{clientId}/{registrationId}`}</h3>
    <p>{`Deletes an event registration.`}</p>
    <h4 {...{
      "id": "parameters-11"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clientId `}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IMS client ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`registrationId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ID of registration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Ams-Consumer-Id`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS consumer ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Ams-Application-Id`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS application ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-11"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
| Code | Description |
|---|---|
| `}<em parentName="p">{`default`}</em>{` | Successful operation |`}</p>
    <h3 {...{
      "id": "put-runtimenamespacesorgidintidhandleeventupdateclientidregistrationid"
    }}>{`PUT /runtime/namespaces/{orgId}/{intId}/handleEventUpdate/{clientId}/{registrationId}`}</h3>
    <p>{`Updates an event registration.`}</p>
    <h4 {...{
      "id": "parameters-12"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`orgId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`intId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`clientId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IMS client ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`registrationId (string: path)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Registration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`X-Ams-Consumer-Id (string: header)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS consumer ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`X-Ams-Application-Id (string: header)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS application ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`body (body)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Example value:`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`{
"id": "string",
"name": "string",
"description": "string",
"client_id": "string",
"type": "string",
"integration_status": "string",
"delivery_type": "string",
"webhook_url": "string",
"events_of_interest": `}{`[
{
"event_code": "string",
"provider": "string"
}
]`}{`,
"runtime_action": "string",
"registration_id": "string"
}Parameter content type: application/json
Model:
EventDTO {
description: Adobe I/O Event Details
id                  string
Event id
name                string
Event name
description         string
Event code
Client id           string
Event namespace
type                string
Event type
integration_status  string
Event integration status
delivery_type       string
Event delivery type
webhook_url         string
Webhook url
events_of_interest  `}{`[
Events of interest to listen to
EventsOfInterestDTO{
description: Events of interest
event_code  string
Event code
provider    string
Event provider
}]`}{`
runtime_action      string
Action to handle event
registration_id     string
Event registration id
}|
|Authorization (string: header)|Authorization token in format: Bearer {token}|
|X-Api-Key (string: header)|Api key|`}</p>
    <h4 {...{
      "id": "responses-12"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"id": "string",
"name": "string",
"description": "string",
"client_id": "string",
"type": "string",
"integration_status": "string",
"delivery_type": "string",
"webhook_url": "string",
"events_of_interest": `}{`[
{
"event_code": "string",
"provider": "string"
}
]`}{`,
"runtime_action": "string",
"registration_id": "string"
}
Model:
EventDTO {
description: Adobe I/O Event Details
id                  string
Event id
name                string
Event name
description         string
Event code
Client id           string
Event namespace
type                string
Event type
integration_status  string
Event integration status
delivery_type       string
Event delivery type
webhook_url         string
Webhook url
events_of_interest  `}{`[
Events of interest to listen to
EventsOfInterestDTO{
description: Events of interest
event_code  string
Event code
provider    string
Event provider
}]`}{`
runtime_action      string
Action to handle event
registration_id     string
Event registration id
}|`}</p>
    <h3 {...{
      "id": "post-runtimenamespacesorgidintidhandleeventstatusclientidregistrationidstatus"
    }}>{`POST /runtime/namespaces/{orgId}/{intId}/handleEventStatus/{clientId}/{registrationId}/{status}`}</h3>
    <p>{`Updates the status of an event registration.`}</p>
    <h4 {...{
      "id": "parameters-13"
    }}><em parentName="h4">{`Parameters:`}</em></h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`orgId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Organization ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`intId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integration ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clientId `}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`IMS client ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`registrationId`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ID of registration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`status`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Status of the registration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Ams-Consumer-Id`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS consumer ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Ams-Application-Id`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`path`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AMS application ID`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Authorization`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization token in format: `}<inlineCode parentName="td">{`Bearer {token}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode>{` (`}<inlineCode parentName="td">{`string`}</inlineCode>{`: `}<em parentName="td">{`header`}</em>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Api key`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "responses-13"
    }}><em parentName="h4">{`Responses:`}</em></h4>
    <p>{`Response content type: `}<inlineCode parentName="p">{`application/json`}</inlineCode>{`
|Code|Description|
|--- |--- |
|200|Successful operation Example value:
{
"id": "string",
"name": "string",
"description": "string",
"client_id": "string",
"type": "string",
"integration_status": "string",
"delivery_type": "string",
"webhook_url": "string",
"events_of_interest": `}{`[
{
"event_code": "string",
"provider": "string"
}
]`}{`,
"runtime_action": "string",
"registration_id": "string"
}
Model:
EventDTO {
description: Adobe I/O Event Details
id                  string
Event id
name                string
Event name
description         string
Event code
Client id           string
Event namespace
type                string
Event type
integration_status  string
Event integration status
delivery_type       string
Event delivery type
webhook_url         string
Webhook url
events_of_interest  `}{`[
Events of interest to listen to
EventsOfInterestDTO{
description: Events of interest
event_code  string
Event code
provider    string
Event provider
}]`}{`
runtime_action      string
Action to handle event
registration_id     string
Event registration id
}|`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      